<div class="empty-page">
  <div class="banner" [bg-image]="locImage"></div>
  <img [src]="organizationLogo" class="banner-logo" alt="organization icon"/>
  <div class="message">
    Please scan the QR code on your table to use
    {{ organizationName }} Lounge Services.
  </div>
</div>
